import {
    Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "flowbite-react";
import { useState, useEffect } from "react";

export default function ClientTable({clis, setEid, opModal}) {
  const [clients, setClients] = useState([]);

  const clientSample = [
    {
      tp: "0774868036",
      c_name: "True Blue",
      note: "I'm sample sample asampe asample",
    },
    {
      tp: "0774868033",
      c_name: "Perfect Ads",
      note: "I'm sample sample asampe asample",
    },
  ];

  useEffect(() => {
    setClients(clis);
    console.log("cleints here: ", clients);
  }, [clis]);

  const handleEdit =async(id)=>{
    setEid(id);
    opModal();
  };

  return (
    <div className="overflow-x-auto rounded-lg border-2 border-white shadow-sm">
      <Table striped hoverable>
        <TableHead className="bg-gray-800">
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Client Name
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            TP
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Note
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            <span className="sr-only">Edit</span>
          </TableHeadCell>
        </TableHead>

        <TableBody className="divide-y divide-gray-700">
          {clients.map((client, index) => (
            <TableRow
              key={index} // Use unique ID in real app (e.g. client.id)
              className={`${
                index % 2 === 0 ? "bg-gray-800" : "bg-gray-900"
              } hover:bg-gray-700 transition-colors`}
            >
              <TableCell className="whitespace-nowrap font-medium text-white">
                {client.c_name}
              </TableCell>
              <TableCell className="text-gray-300">{client.tp}</TableCell>
              <TableCell className="text-gray-300">
                {client.note.length > 60
                  ? client.note.substring(0, 57) + "..."
                  : client.note}
              </TableCell>
              <TableCell>
                <Button
                  onClick={()=>handleEdit(client.id)}
                  className="font-medium text-white hover:underline dark:text-white hover:text-blue-300"
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}

          {clients.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-8 text-gray-400">
                No clients found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
